"use client";
import ContactForm from "@/components/cards/contactForm";
import SignUpForFreeSection from "@/components/cards/signUpForFreeSection";
import MainLayout from "@/components/layout/mainLayout";
import { useLocalsListStore } from "@/zustand/localesList";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import api from "../../../api";
import { getCookie } from "../../../helper/helper";
import BuyNowCart from "@/components/common/BuyNowCart";
import { getCheckoutLineItems } from "@/util/utils";
import { useAppCommonStore } from "@/zustand/appCommon";

const Contactus = () => {
  const pathname = usePathname();

  const [show, setShow] = useState(true);

  const [showMobileFilter, setShowMobileFilter] = useState(false);
  const {
    checkout,
    setCheckout,
    selectedCountry,
    updateQuantityInCart,
    removeLineItemInCart,
    openModal,
    toggleCartSidebar,
  } = useAppCommonStore((state: any) => ({
    checkout: state.checkout,
    setCheckout: state.setCheckout,
    selectedCountry: state.selectedCountry,
    updateQuantityInCart: state.updateQuantityInCart,
    removeLineItemInCart: state.removeLineItemInCart,
    openModal: state.openModal,
    toggleCartSidebar: state.toggleCartSidebar,
  }));

  const handleClose = () => {
    setShowMobileFilter(!showMobileFilter);
  };

  const [templateData, setTemplateData]: any = useState([]);

  const localesList = useLocalsListStore(
    (state: any) => state.localesList
  );

  const locale = localesList.locale || getCookie("locale") || "en-US";
  const getMasterTemplateData = (props: any) => {
    api
      .getMasterTemplate(props)
      .then((res: any) => {
        if (res?.data) {
          setTemplateData(res.data.attributes?.newsletter[0]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (locale) {
      getMasterTemplateData(locale);
    }
  }, [locale]);

  useEffect(() => {
    getCheckoutLineItems(selectedCountry.value).then((res) => {
      setCheckout({
        ...res,
      });
    });
  }, []);

  return (
    <>
      <BuyNowCart
        countryCode={selectedCountry.value}
        openModal={openModal}
        toggleCartSidebar={toggleCartSidebar}
        checkout={checkout}
        updateQuantityInCart={updateQuantityInCart}
        removeLineItemInCart={removeLineItemInCart}
      />
      <MainLayout
        checkout={checkout}
        toggleCartSidebar={toggleCartSidebar}
      >
        <div className="contact-us-wrapper">
          <h2 className="headingText">
            We are happy to hear from you
          </h2>
          <div className="tab-container">
            <ul>
              <Link href={`/contact-us`}>
                <li
                  onClick={() => setShow(true)}
                  // className={show == true ? `active` : ""}
                  className={
                    pathname == "/contact-us" ? `active` : ""
                  }
                >
                  Contact Us
                </li>
              </Link>
              <Link href={"/locate-us"}>
                <li
                  onClick={() => setShow(false)}
                  // className={show == false ? `active` : ""}
                  className={pathname == "/locate-us" ? `active` : ""}
                >
                  Locate Us
                </li>
              </Link>
            </ul>
          </div>
          {/* {show == true ? <ContactForm /> : <Locate />} */}
          <ContactForm />
        </div>
        <SignUpForFreeSection templateData={templateData} />
      </MainLayout>
    </>
  );
};

export default Contactus;
